import { render, staticRenderFns } from "./partnerRemittanceRanking.vue?vue&type=template&id=5ab3db9b&scoped=true&"
import script from "./partnerRemittanceRanking.vue?vue&type=script&lang=js&"
export * from "./partnerRemittanceRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3db9b",
  null
  
)

export default component.exports